import {
    DEFAULT_LOCALE,
    EVANEOS_LOCALES,
    LOCALES,
    PRISMIC_LOCALES,
} from '../../configurations/locales';
import { getSiteByLocale, getSiteByLocaleEvaneos, getSiteByLocalePrismic } from '../Site/Site';

export type Locale = (typeof LOCALES)[number];

export type LocaleEvaneos = (typeof EVANEOS_LOCALES)[number];

export type LocalePrismic = (typeof PRISMIC_LOCALES)[number];

export function getAllLocales(): ReadonlyArray<Locale> {
    return LOCALES;
}

export function getLocaleFromLocaleEvaneos(localeEvaneos: LocaleEvaneos): Locale {
    return getSiteByLocaleEvaneos(localeEvaneos).locale;
}

export function getLocaleEvaneosFromLocale(locale: Locale): LocaleEvaneos {
    return getSiteByLocale(locale).localeEvaneos;
}

export function getLocalePrismicFromLocale(locale: Locale): LocalePrismic {
    return getSiteByLocale(locale).localePrismic;
}

export function getLocaleFromLocalePrismic(localePrismic: LocalePrismic): Locale {
    return getSiteByLocalePrismic(localePrismic).locale;
}

export function isLocale(locale: string): locale is Locale {
    return getAllLocales().includes(locale as Locale);
}

export function getDefaultLocale(): Locale {
    return DEFAULT_LOCALE;
}
